const PositionObject = {
  id: undefined,
  code: '',
  name: '',
};

export default PositionObject;